<template>
  <div>
    <main class="main-grid">
      <!-- Left Section: Form for Delivery Info -->
      <div class="form-section">
        <section class="shop">
          <i class="fas fa-money-bill-wave"></i>
          <h1>Payment</h1>
        </section>

        <form class="contact-form" @submit.prevent="openTipModal">
          <div class="form-group">
            <label for="discount">Discount</label>
            <input v-model="discount" type="text" id="discount" placeholder="WELCOME20" />
          </div>

          <div class="form-group">
            <label for="paymentMethod">Select Payment Method</label>
            <select v-model="paymentMethod" required id="paymentMethod">
              <option disabled value="">-- Select --</option>
              <option>PayPal</option>
              <option>Papara</option>
              <option>Crypto</option>
            </select>
          </div>

          <button class="back-btn" type="button" @click="$emit('back')">Back</button>
          <button class="next-btn" type="submit">Next</button>
        </form>
      </div>

      <div class="order-summary">
        <h2>Order Summary</h2>
        <ul>
          <li v-for="(item, index) in cart" :key="index" class="order-item">
            <img :src="item.image" alt="Product Image" class="item-image" />
            <strong>{{ item.name }} x{{ item.quantity }} - ${{ (item.price * item.quantity).toFixed(2) }}</strong>
          </li>
        </ul>

        <div class="total-price">
          <strong>Total:</strong> ${{ totalPrice.toFixed(2) }}
        </div>

        <div v-if="submittedData">
          <h3>Payment Details</h3>
          <p><strong>Discount Code:</strong> {{ submittedData.discount }}</p>
          <p><strong>Payment Method:</strong> {{ submittedData.paymentMethod }}</p>
          <p><strong>Tip:</strong> ${{ submittedData.tip ? submittedData.tip : 'No tip given' }}</p>
        </div>
      </div>

      <TipModal v-if="showModal" @close="showModal = false" @choose="handleTipChoice" />
    </main>
  </div>
</template>

<script>
import TipModal from './modal/TipModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DeliveryStage',
  components: { TipModal },
  props: {
    formData: Object
  },
  data() {
    return {
      discount: '',
      paymentMethod: '',
      tip: 0,
      showInput: false,
      showModal: false,
      submittedData: null,
    }
  },
  computed: {
    ...mapGetters(['cart']),

    totalPrice() {
      return this.cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);
    }
  },
  methods: {
    openTipModal() {
      this.showModal = true;
    },
    handleTipChoice(tip) {
      this.showModal = false;

      const formData = {
        discount: this.discount,
        paymentMethod: this.paymentMethod,
        tip,
        cart: this.cart
      };

      this.submittedData = formData;

      this.$emit('updateForm', formData);
      this.$emit('next');
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  padding: 2rem;
  color: #fff;
  flex-wrap: wrap;
}

.form-section,
.order-summary {
  display: flex;
  flex-direction: column;
}

.form-section {
  flex: 1;
  max-width: 500px;
  gap: 2rem;
}

.order-summary {
  flex: 1;
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  margin-top: 2rem;
}

.order-summary h2 {
  font-size: 1.6rem;
  color: cornflowerblue;
  margin-bottom: 1rem;
}

.order-summary ul {
  list-style: none;
  padding: 0;
}

.order-summary li {
  margin-bottom: 0.7rem;
  font-size: 1.1rem;
  color: #ccc;
  display: flex;
  align-items: center;
}

.order-summary .item-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  object-fit: cover;
}

.total-price {
  margin-top: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
  color: cornflowerblue;
}

.shop {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
  margin-bottom: 1rem;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}

.contact-form {
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: cornflowerblue;
}

input {
  width: 100%;
  padding: 0.7rem;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #111;
  color: #fff;
  font-size: 1rem;
}

select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #444;
  background: #333;
  color: #fff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}

select::-ms-expand {
  display: none;
}

select::after {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1rem;
}

input, select {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #444;
  background: #333;
  color: #fff;
}

.next-btn {
  margin-top: 1rem;
  padding: 0.8rem 2rem;
  background-color: cornflowerblue;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.next-btn:hover {
  background-color: royalblue;
}

.back-btn {
  margin-right: 1rem;
  padding: 0.8rem 2rem;
  background-color: #555;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.back-btn:hover {
  background-color: #777;
}

</style>